/*
 * @author Oleksandr Papka <papkaos>
 */
angular.module('popup.system-package').directive('gccsPopupSystemPackageClientManagersExceed', [
  'popupDirectiveConfig',
  popupDirectiveConfig =>
    popupDirectiveConfig.configure({
      bodyTemplate: require('./template.pug')
    })
]);
